<form [formGroup]="dealerForm">
    <mat-form-field class="col" appearance="fill">
        <mat-label>Dealer Deal #</mat-label>
        <mat-placeholder>Dealer Deal #</mat-placeholder>
        <input class="form-control" type="text" matInput formControlName="dealerDealNumber" maxlength="20" />
        <mat-error>Invalid Dealer Deal #</mat-error>
    </mat-form-field>
</form>
